import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { CircleCheck } from "lucide-react";
export default function FamilyStoryAboutUs() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: imgRef,
    isVisible: imgVisible
  } = useRevealOnScroll();
  return <section id="family-story-about-us" className="bg-background py-20 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div ref={textRef} className={cn("flex flex-col gap-6 transition-all duration-1000 ease-out transform", textVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10")}>
            <div className="space-y-4">
              <span className="text-primary font-bold tracking-widest uppercase text-xs">
                Our Story
              </span>
              <h2 className="text-4xl md:text-5xl font-sans font-extrabold tracking-tighter text-foreground leading-[1.1]">
                Built on Work Ethic. <br />
                Driven by Pride.
              </h2>
              
            </div>

            <div className="prose prose-lg text-foreground/80 font-medium">
              <p>
                Pure Detail Cleaning is more than just a service; it is a
                reflection of our personal values. As a family-owned business
                serving Central Texas, we founded this company on a simple yet
                powerful belief:{" "}
                <span className="text-primary font-bold">
                  how you do anything is how you do everything.
                </span>
              </p>
              <p>
                We don’t believe in cutting corners. Whether it’s a recurring
                residential clean or a complex move-out project, we approach
                every task with the same level of discipline and ownership.
                Clean spaces create clarity and peace of mind, and we take that
                responsibility seriously.
              </p>
              <p>
                Led by Daniela and Dallas, our team is committed to bringing a
                higher standard to the industry. We combine professional
                precision with the care and accountability you expect from a
                local, owner-operated business.
              </p>
            </div>

            <div className="pt-4 flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" variant="secondary" className="rounded-none px-8 font-bold">
                <Link to="/PureDetailBookingPage">
                  Book Online
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-primary text-primary hover:bg-primary hover:text-white rounded-none px-8 font-bold">
                <Link to="/ContactPage">
                  Call or Text Directly
                </Link>
              </Button>
            </div>

            {}
            <div className="pt-8 border-t border-border mt-2">
              <div className="flex items-center gap-12">
                <div>
                  <p className="font-sans text-lg font-extrabold text-foreground uppercase tracking-tight">Dallas Dodd</p>
                  <p className="text-xs font-bold text-primary uppercase tracking-widest">Co-Founder</p>
                </div>
                <div>
                  <p className="font-sans text-lg font-extrabold text-foreground uppercase tracking-tight">Daniela Collazo</p>
                  <p className="text-xs font-bold text-primary uppercase tracking-widest">Co-Founder</p>
                </div>
              </div>
            </div>
          </div>

          {}
          <div ref={imgRef} className={cn("relative transition-all duration-1000 ease-out delay-200 transform", imgVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10")}>
            <div className="relative aspect-[4/5] w-full max-w-md mx-auto lg:max-w-full lg:ml-auto">
              {}
              <div className="absolute -top-6 -right-6 w-full h-full bg-secondary/30 z-0 hidden md:block" />
              
              <img src="https://puredetailcleaning.com/wp-content/uploads/2026/04/IMG_1664-scaled.jpg" alt="Daniela and Dallas, founders of Pure Detail Cleaning" className="relative z-10 w-full h-full object-cover rounded-none shadow-2xl bg-muted" />
              
              {}
              <div className="absolute bottom-8 -left-8 z-20 bg-white p-6 shadow-xl rounded-none border border-border max-w-[240px] hidden md:block">
                <div className="flex items-start gap-3">
                  <CircleCheck className="w-6 h-6 text-primary shrink-0 mt-1" />
                  <div>
                    <p className="font-extrabold text-foreground text-sm uppercase tracking-tight">
                      Owner-Operated
                    </p>
                    <p className="text-xs text-foreground/70 mt-1 leading-relaxed">
                      Hands-on oversight on every project for guaranteed quality.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}